// extracted by mini-css-extract-plugin
module.exports = {"photo":"ServiceSingle_photo__Y7HFf","info":"ServiceSingle_info__1BBwT","step":"ServiceSingle_step__2pt9b","wrapper":"ServiceSingle_wrapper__3uTuk"};